module.exports = __webpack_public_path__ + "img/chess_chinesechessred1.9d410f22.png";